/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type AnimalPublicTagSearchQueryVariables = {};
export type AnimalPublicTagSearchQueryResponse = {
    readonly configuration: {
        readonly licensingRecaptchaSiteKey: string | null;
        readonly licensingRecaptchaSiteKeyV3: string | null;
    } | null;
};
export type AnimalPublicTagSearchQuery = {
    readonly response: AnimalPublicTagSearchQueryResponse;
    readonly variables: AnimalPublicTagSearchQueryVariables;
};



/*
query AnimalPublicTagSearchQuery {
  configuration {
    licensingRecaptchaSiteKey
    licensingRecaptchaSiteKeyV3
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "Configuration",
            "kind": "LinkedField",
            "name": "configuration",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "licensingRecaptchaSiteKey",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "licensingRecaptchaSiteKeyV3",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "AnimalPublicTagSearchQuery",
            "selections": (v0 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "AnimalPublicTagSearchQuery",
            "selections": (v0 /*: any*/)
        },
        "params": {
            "cacheID": "fb5a963a107fd185604f2be2cd2d8ecf",
            "id": null,
            "metadata": {},
            "name": "AnimalPublicTagSearchQuery",
            "operationKind": "query",
            "text": "query AnimalPublicTagSearchQuery {\n  configuration {\n    licensingRecaptchaSiteKey\n    licensingRecaptchaSiteKeyV3\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '983c8d8fa61d9ec794d268e076c525c3';
export default node;
